
// import { ListColumn } from './../../../core/list/list-column.model';
// import { ItemCategoryComponent } from './../item-category/item-category.component';
// import { DatePipe } from '@angular/common';
// import { ItemServiceService } from '../../../services/setup/item-service.service';

import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';

const _clone = (d) => JSON.parse(JSON.stringify(d));
import { environment } from '../../../../../environments/environment';
import { OrderService } from 'src/app/POS/POSServices/Setup/order.service';

@Component({
  selector: 'app-order-receipt-list',
  templateUrl: './order-receipt-list.component.html',
  styleUrls: ['./order-receipt-list.component.scss']
  //providers:[OrderService] ,
})
export class OrderReceiptListComponent implements OnInit {
 // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;
    InvoiceList: any[]; 
    PaidInvoicelist: any[]
    PendingInvoicelist: any[]
    tableHover = true;
    tableStriped = true;
    tableCondensed = true;
    tableBordered = true;
    resultsLength:any;
  
    // columns: ListColumn[] = [
      
    //   { name: 'AddNoofBlankLineTopOfReceipt', property: 'AddNoofBlankLineTopOfReceipt', visible: true, isModelProperty: true },
    //   { name: 'OrderNumberType ', property:'OrderNumberType',visible:true,isModelProperty:true},
    //   { name: 'BusinessName', property:'PosSubscriptionId',visible:false,isModelProperty:true},
    //    { name: 'Notes', property: 'actions', visible: true },   
    //       ] as ListColumn[];
    AlldataSource;
    PaidInvoicedataSource;
    PendingInvoicedataSource;
    posId: any;
    rows = [];
    temp = [];
  

  constructor(private service: OrderService, private commonfunction: CommonFunctionService) {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
  
    this.posId= merchantdata.PosSubscriptionId;
        this.GetOrderReceiptlist((data) => {
          // cache our list
          this.temp = _clone(data);
          this.rows = _clone(data);;
      });


    // this.service.GetOrderReceiptlist(merchantdata.PosSubscriptionId)
    // .subscribe(data => {     
    // this.AlldataSource = new MatTableDataSource<Employee>(data.map(result => new Employee(result)));
    // this.AlldataSource.paginator = this.paginator;
    // this.AlldataSource.sort = this.sort;
    // this.AlldataSource.columns = this.columns;
    // });

   }

  ngOnInit() {
  }
   
    // get visibleColumns() {
    //   return this.columns.filter(column => column.visible).map(column => column.property);
    // }
  
    GetOrderReceiptlist(cb) {
      const req = new XMLHttpRequest();
      
      req.open('GET',environment.GetOrderReceiptlistUrl + "?PosSubscriptionId=" + this.posId);
     
      req.onload = () => {
          cb(JSON.parse(req.response));
      };
  
      req.send();
  }
  

}




 // export class Employee {
  
  //   Id: any;
  //   AddNoofBlankLineTopOfReceipt : any;
  //   OrderNumberType : any;
  //   PosSubscriptionId:any;
  //   constructor(res) {
  //     this.Id = res.Id;
  //     this.AddNoofBlankLineTopOfReceipt  = res.AddNoofBlankLineTopOfReceipt ;
  //     this.OrderNumberType  = res.OrderNumberType ;
  //     this.PosSubscriptionId = res.PosSubscriptionId;
  //   }
  
  // }